export const subscription = {
  titles: {
    subscription: "Abonnement",
    freeTrial: "Essai gratuit",
    expired: "Expiré",
  },

  status: {
    active: "Actif",
    canceled: "Annulé",
    trialAccess: "ESSAI GRATUIT",
    expiredAccess: "ACCÈS EXPIRÉ",
  },

  notices: {
    activeDesc: "Gérez les détails de votre abonnement et les options d'amélioration.",
    canceledDesc:
      "Votre abonnement a été annulé. Vous conserverez l'accès jusqu'à la date de fin.",
    trialDesc: "Vous avez accès aux fonctionnalités du système jusqu'à la date d'expiration.",
    expiredDesc:
      "Votre période d'essai est terminée. Abonnez-vous pour continuer à utiliser le service.",
    upgradeHint:
      "Ne perdez pas l'accès aux fonctionnalités avancées, améliorez votre abonnement dès maintenant",
    expiredHint:
      "Votre accès a expiré. Abonnez-vous pour continuer à utiliser toutes les fonctionnalités",
    needFullAccess: "Besoin d'un accès complet ?",
    choosePlan: "Choisissez un forfait qui vous convient",
  },

  labels: {
    planActive: "Forfait actif",
    stateNow: "Statut actuel",
    trialPeriod: "Période d'essai",
    periodExpired: "Période expirée",
    summary: "Récapitulatif de l'abonnement",
    timeLeft: "Temps restant",
    trialExpiresIn: "Votre essai gratuit expire dans {days} jours",
    expirationDate: "Date d'expiration",
    nextRenewal: "Prochain renouvellement",
    accessUntil: "Accès disponible jusqu'au",
    perUnit: "/ Par {unit}",
    unitRoom: "Chambre",
    unitRoomMultiple: "Plusieurs chambres",
    unitApartment: "Appartement",
    unitVilla: "Villa",
    unitCamping: "Camping",
    unitLodging: "Hébergement",
    annualPlan: "Forfait annuel",
    monthlyPlan: "Forfait mensuel",
  },

  actions: {
    addUnit: "Ajouter {unitLabel}",
    manageSubAndPayment: "Gérer l'abonnement et le moyen de paiement",
    processing: "Traitement...",
    subscribeNow: "S'abonner maintenant",
    chooseAPlan: "Choisir un forfait",
    goToSubscriptionPage: "Aller aux forfaits",
  },

  confirmCancel: {
    title: "Annuler l'abonnement ?",
    text: "Si vous annulez, vous perdrez l'accès à vos services.",
    confirm: "Oui, annuler",
    cancel: "Non",
  },

  formats: {
    priceTotalHTML: "{price}",
    dateDDMMYYYY: "{date}",
  },

  modal: {
    title: 'Abonnement activé !',
    details: "Détails de l'abonnement",
    welcomeTitle: "Bienvenue sur WA Checkin {plan} !",
    welcomeBody:
      "Vous avez désormais un accès complet à nos outils de check-in WhatsApp, à la synchronisation OTA, au chatbot IA, aux automatisations et bien plus encore.",
    feature1: {
      title: "Gérer les tarifs et les disponibilités",
      desc: "Modifiez facilement vos prix et contrôlez l'occupation en temps réel, le tout depuis un seul endroit.",
    },
    feature2: {
      title: "Obtenir des réservations directes",
      desc: "Depuis votre propre site web, les clients peuvent réserver directement sans passer par les OTA.",
    },
    schedule: {
      help: "Planifiez un appel vidéo gratuit et nous vous aiderons à tout configurer.",
      cta: "Planifier un appel vidéo",
    },
  },

  sectionPlans: {
    title: "Liste des forfaits",
    confirm: {
      header: "Confirmer l'amélioration du forfait",
      loadingMsg: "Mise à jour de votre forfait, veuillez patienter.",
      body: "Vous êtes sur le point de changer le forfait de votre compte pour {plan}.",
    },
    actions: {
      cancel: "Annuler",
      confirmUpgrade: "Confirmer l'amélioration",
      goToBilling: "Aller aux moyens de facturation",
      accept: "OK",
      updateSubscription: "Mettre à jour l'abonnement", // NEW
    },
    success: {
      title: "Succès",
      body: "Votre abonnement a été mis à jour.",
    },
    errors: {
      processTitle: "Erreur lors du traitement de la demande",
      unknownUpdate: "Erreur inconnue lors de la mise à jour de l'abonnement.",
      genericTitle: "Erreur",
      genericBody: "L'abonnement n'a pas pu être mis à jour.",
    },
  },

  plans: {
    features: {
      installation: "Accompagnement personnalisé par un expert",
      fastSupport: "Assistance rapide par e-mail, chat et téléphone",
      whatsappCheckin: "Check-in via WhatsApp",
      linkEmailCheckin: "Check-in via lien / e-mail",
      welcomeMessage: "Message de bienvenue via WhatsApp et e-mail",
      digitalSignature: "Signature numérique des politiques",
      idScanner: "Scanner de pièce d'identité / passeport",
      sesHospedajesSend: "Envoi automatique des déclarations à la police",
      reviewLink: "Envoi du lien d'avis Google après le check-out",
      smartLocks: "Connexion avec vos serrures connectées",
      channelManager1: "Channel Manager (connexion avec 1 OTA)",

      includesLite: "Tout ce qui est inclus dans Lite",
      selfieVerification: "Vérification du client au check-in par selfie",
      unifiedInbox: "Boîte de réception unifiée",
      upsellServices: "Proposer des services et des expériences via WhatsApp",
      paymentLinks: "Encaissements clients (lien de paiement par carte)",
      websiteBookings: "Site web de réservation avec calendrier synchronisé",
      channelManagerUnified: "Channel Manager (calendriers unifiés, plus de 100 OTA)",
      channelManagerCentralPrices:
        "Channel Manager (gestion centralisée des prix)",
      guestSupportOption: "Option pour souscrire au Guest Support",

      includesStandard: "Tout ce qui est inclus dans Standard",
      centralizedPriceManager: "Gestionnaire de prix centralisé",
      aiChatbot: "Chatbot IA WhatsApp (FAQ et automatisation)",
      googleVacationRentals: "Intégration Google Vacation Rentals",
      whatsappReminders: "Rappels WhatsApp pour les clients",
      eInvoicingSoon: "Facturation électronique (bientôt disponible)",
      prioritySupport: "Assistance prioritaire",
    },
  },

  planCard: {
    perSlash: "/par", // separator "/per {unit}"
    infoTitle: "Détails du forfait",
    update: "Mettre à jour",
    subscribe: "S'abonner",
    currentPlan: "Forfait actuel",
    byApartment: "par appartement",
    byVilla: "par villa",
    byCamping: "par camping",
    byRoom: "par chambre",
    byUnit: "par logement",
  },

  services: {
    title: "Services supplémentaires",
    ctaComingSoon: "Bientôt disponible",
    guestSupport: {
      title: "Service Guest Support",
      subtitle: "Nous gérons pour vous les messages WhatsApp et les appels téléphoniques de vos clients.",
      desc: "Nous les assistons lors du check-in, répondons à leurs questions et gérons également les appels de réservation directe. Vous vous détendez pendant qu'ils bénéficient d'une expérience 10/10 dès le premier contact.",
    },
    chatbot: {
      title: "ChatBot IA",
      activeService: "Service actif",
      desc: "Ajoutez le service de chatbot IA et automatisez les demandes de vos clients rapidement et efficacement.",
      activateCta: "Activer le service",
      confirm: {
        header: "Confirmer l'activation",
        loadingMsg: "Activation du service ChatBot, veuillez patienter.",
        body: "Vous êtes sur le point d'activer le service ChatBot IA pour vos {units} hébergements.",
      },
      discount: {
        applied: "Remise appliquée :",
        couponFallback: "Coupon",
      },
      pricing: {
        unitPrice: "Prix unitaire :",
        quantity: "Quantité :",
        totalToPay: "Total à payer :",
      },
    },
  },

  invoices: {
    title: "Factures et reçus",
    created: "Créée",
    status: "Statut",
    amount: "Montant",
    paid: "Payée",
    unpaid: "Impayée",
    viewInvoice: "Voir la facture",
    empty: "Vous n'avez pas encore de factures.",
  },

  updateModal: {
    header: "Ajouter des {unitLabel}s",
    body: "Ajoutez le nombre de {unitLabelPlural} à votre abonnement.",
    pricing: {
      discountApplied: "Remise appliquée à l'abonnement :",
      unitPrice: "Prix unitaire :",
      quantity: "Quantité :",
      totalNewUnits: "Total pour les nouveaux logements :",
      newSubscriptionTotal: "Nouvelle valeur totale de l'abonnement :",
    },
    prorationNote:
      "Les changements d'abonnement sont calculés au prorata en fonction des jours restants dans la période en cours. La facturation complète s'appliquera le mois prochain.",
  },

  page: {
    findRightPlan: "Trouvez le forfait qui vous convient",
    enterAmount: "Saisissez le montant",
    numberOf: "Nombre de {unit}"
  },
  billing: {
    title: "Sélectionnez la période de facturation",
    subtitle: "Choisissez votre mode de paiement",
    monthly: "Mensuel",
    annual: "Annuel",
    discountShort: "−{percent}%",
  },
};
